import {Component, ViewChild} from '@angular/core';
import {Nav, Platform} from 'ionic-angular';
import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';
import {TranslateService} from '@ngx-translate/core'
import {Subscription} from "rxjs";
import {FirebaseAuthProvider} from "../providers/firebase/firebaseAuthProvider";

@Component({
    templateUrl: 'app.html'
})
export class MyApp {
    rootPage: string = "LoginPage";
    loggedInUser;

    @ViewChild(Nav) nav;

    subscriptions = Array<Subscription>(); // to keep track of all the firebase subscriptions

    constructor(
        platform: Platform,
        statusBar: StatusBar,
        splashScreen: SplashScreen,
        private translate: TranslateService,
        private firebaseAuthProvider: FirebaseAuthProvider) {

        //console.group("In constructor of app.component.ts");
        console.debug("auth: ", this.firebaseAuthProvider.isAuthenticated());
        console.debug("current user: ", this.firebaseAuthProvider.getCurrentUser());
        if (this.firebaseAuthProvider.getCurrentUser()) {
            console.log("email verified: ", this.firebaseAuthProvider.getCurrentUser().emailVerified);
        }
        console.groupEnd();

        // wait for auth change

        this.firebaseAuthProvider.getCurrentUserSubject().subscribe(user => {
            if (!this.firebaseAuthProvider.isAuthenticated() || !this.firebaseAuthProvider.getCurrentUser().emailVerified) {
                console.log("Not authenticated or email not verified");
                this.rootPage = "LoginPage";
                return;
            }

            if (this.firebaseAuthProvider.isDoctor()) {
                console.debug('User role: doctor');
                this.rootPage = "DoctorPage";
            } else {
                console.debug('User role: patient');
                this.rootPage = "TabPage";
            }

            console.debug(("ROOT page: " + this.rootPage));

        });


        this.initTranslate();
        platform.ready().then(() => {
            // Okay, so the platform is ready and our plugins are available.
            // Here you can do any higher level native things you might need.
            statusBar.styleDefault();
            splashScreen.hide();
        });
    }

    // observables beenden bei Seitenwechsel
    ionViewWillLeave() {
        console.log("In ionViewWillLeave() of app.component.ts---->unsubscribe from all the subscriptions");
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        })
    }

    initTranslate() {
        // Set the default language for translation strings, and the current language.
        this.translate.setDefaultLang('de');

        if (this.translate.getBrowserLang() !== undefined) {
            this.translate.use(this.translate.getBrowserLang());
        } else {
            this.translate.use('de'); // Set your language here
        }

        /*     this.translate.get(['BACK_BUTTON_TEXT']).subscribe(values => {
              this.config.set('ios', 'backButtonText', values.BACK_BUTTON_TEXT);
            }); */
    }

}






// WEBPACK FOOTER //
// ./src/app/app.component.ts